export default __webpack_public_path__ + "static/media/homeIcon.3dc31484.svg";